import { defineMessages } from '@jutro/locale';

export default defineMessages({
    VehiclesInvolved: {
        id: 'ml.gateway.views.AccountClaims.VehiclesInvolved.Vehicles Involved',
        defaultMessage: 'Vehicles Involved'
    },
    yourCar: {
        id: 'ml.gateway.views.AccountClaims.VehiclesInvolved.YOUR CAR',
        defaultMessage: 'YOUR CAR'
    },
    licensePlate: {
        id: 'ml.gateway.views.AccountClaims.VehiclesInvolved.License Plate',
        defaultMessage: 'License Plate: {license}'
    },
    color: {
        id: 'ml.gateway.views.AccountClaims.VehiclesInvolved.Color',
        defaultMessage: 'Color: {color}'
    },
    otherCar: {
        id: 'ml.gateway.views.AccountClaims.VehiclesInvolved.OTHER CAR',
        defaultMessage: 'OTHER CAR'
    }


});
